export class DateFormatterValueConverter {
    toView(value, type = 'calendar', format) {
        if (!value) {
            throw new Error('Date value cannot be empty');
        }

        const date = new Date(value);

        switch (type) {
            case 'calendar': {
                // There isn't a direct equivalent of moment's 'calendar' in Intl,
                // so you might need to implement custom logic depending on your needs.
                // This is a simple example that just shows today, yesterday, or the full date.
                const today = new Date();
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);

                if (date.toDateString() === today.toDateString()) {
                    return 'Today';
                } else if (date.toDateString() === yesterday.toDateString()) {
                    return 'Yesterday';
                }
                return new Intl.DateTimeFormat('default', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                }).format(date);

            }
            case 'format': {
                const normalizedFormat = String(format || 'MMM DD, YYYY');
                let monthLength: 'long' | 'short' | '2-digit';
                switch (true) {
                    case normalizedFormat.includes('MMMM'):
                        monthLength = 'long';
                        break;
                    case normalizedFormat.includes('MMM'):
                        monthLength = 'short';
                        break;
                    default:
                        monthLength = '2-digit';
                }
                return new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: monthLength,
                    day: 'numeric',
                }).format(date);
            }
            default: {
                // For UTC to local conversion and formatting
                const options = format || {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                };
                return new Intl.DateTimeFormat('default', options).format(new Date(date.toLocaleString()));
            }
        }
    }
}
